import { WorkLog } from "@wingspanhq/wingspan-api-sdk";
import { useMemo } from "react";
import { useQueryPayerRows } from "../../../query/search/payer/queries/useQueryPayerRows";
import { IPayerRow } from "../../../services/search";

export const usePayersMap = (workLogs: WorkLog[] | undefined) => {
  // TODO(v3): v3 WorkLog no longer carries `payerId`, so the payer (client)
  // cannot be joined off the work log. Until a v3 payer source is wired the map
  // stays empty and payer-name columns degrade. Accepted breakage.
  const payerIds = useMemo<string[]>(() => {
    void workLogs;
    return [];
  }, [workLogs]);

  const queryPayerRows = useQueryPayerRows(
    {
      filter: {
        payerId: {
          in: payerIds
        }
      }
    },
    {
      enabled: payerIds.length > 0
    }
  );

  const payersMap = useMemo(() => {
    const map = new Map<string, IPayerRow>();
    (queryPayerRows.data || []).forEach(payer => {
      map.set(payer.payerId, payer);
    });
    return map;
  }, [queryPayerRows.data]);

  return payersMap;
};
